import { Component } from '@angular/core';

/** REV-22155 — shell of the persons area (like `CompaniesPage`). */
@Component({
    selector: 'app-persons',
    template: `<router-outlet></router-outlet>`,
})
export class PersonsPage {}
